import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  DialogContent,
  Dialog,
  Slide,
  IconButton,
  Button,
  Typography,
  DialogTitle,
} from "@material-ui/core";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    background: theme?.colors?.stake?.background,
    minWidth: "100%",
    minHeight: "100%",
    overflow: "auto",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "25px 45px",

    borderRadius: "30px",
  },
  modalRoot: {
    maxWidth: "640px",
    [theme.breakpoints.up("md")]: {
      borderRadius: "30px",
    },
  },
  paper: {
    background: theme?.colors?.swap?.background,
    borderRadius: "30px",
    boxShadow:
      "0px 10px 60px " + theme?.colors?.containerShadow + " !important",
  },
  closeButton: {
    position: "absolute",
    right: "32px",
  },
  screenMask: {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  },
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  walletButton: {
    margin: "15px",

    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    minWidth: "150px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonTextSecondary,
    },
    "&:disabled": {
      opacity: "0.7",
      color: theme?.colors?.wallet?.buttonTextSecondary,
      cursor: "not-allowed",
    },
  },
  cancelButton: {
    borderRadius: "14px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    width: "150px",
    padding: "8px 16px",
    margin: "15px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonText,
    },
  },
  buttonLabel: {
    fontWeight: "bold",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },

  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
  },

  modalHeadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    padding: "8px 24px 0px",
  },

  modalHeadingLogoName: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    fontSize: "25px",
    color: theme?.colors?.presale?.cardTitle,
    fontWeight: 600,
    margin: 0,
  },
  modalCloseIcon: {
    width: "28px",
    height: "28px",
    position: "absolute",
    top: "25px",
    right: "25px",
    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },

  votingWarning: {
    color: theme?.colors?.home?.text,

    fontSize: "20px",
    fontWeight: "normal",
    lineHeight: "18px",
    marginBottom: "30px",
    textAlign: "center",
  },
  unstakeDescription: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginBottom: "30px",
  },
  unstakeTipText: {
    color: theme?.colors?.presale?.commentText,
    fontSize: "17px",
    fontWeight: "normal",
    lineHeight: "25px",
  },
  actionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      alignItems: "center",
    },
  },
  closeIcon: {
    color: theme?.colors?.header?.closeButton,
    width: "32px",
    height: "32px",
  },
});

const UnstakeModal = ({
  classes,
  closeModal,
  modalOpen,
  onUnstake,
  burnFee,
  unstakeMsg,
  lastInvestTimestamp,
  lastUnstakedTime,
}) => {
  const [formattedNoPenaltyDate, setFormattedNoPenaltyDate] = useState("");

  useEffect(() => {
    const lastInvestTimestampMs = lastInvestTimestamp * 1000;
    const lastUnstakedTimeMs = lastUnstakedTime * 1000;

    // Determine the lesser of the two timestamps
    const minTimestampMs = Math.min(lastInvestTimestampMs, lastUnstakedTimeMs);

    // Calculate the date 14 days after the lesser timestamp using moment
    const noPenaltyDate = moment(minTimestampMs).add(14, "days");

    // Format the no penalty date
    setFormattedNoPenaltyDate(noPenaltyDate.format("MM/DD/YYYY"));
  }, [lastInvestTimestamp, lastUnstakedTime]);

  return (
    <Dialog
      open={modalOpen}
      onClose={closeModal}
      fullWidth={true}
      maxWidth={"sm"}
      TransitionComponent={Transition}
      classes={{ paper: classes.paper, paperWidthSm: classes.modalRoot }}
    >
      <DialogTitle disableTypography className={classes.modalHeader}>
        <div className={classes.modalHeadingContainer}>
          <p className={classes.modalHeadingLogoName}>Confirmation</p>
        </div>
        <IconButton
          aria-label="close"
          className={classes.modalCloseIcon}
          onClick={closeModal}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.root }}>
        <div className={classes.modalContainer}>
          <Typography variant="h5" className={classes.votingWarning}>
            {unstakeMsg
              ? unstakeMsg
              : burnFee > 0
              ? `Attention: Please note that a ${burnFee}% burn fee will be applied if
            you unstake before ${formattedNoPenaltyDate}.`
              : "Please be aware that by unstaking you will lose access to IDOs in Starter. Are you sure you would like to continue?"}
          </Typography>

          <div className={classes.actionContainer}>
            <Button
              classes={{
                root: classes.walletButton,
                label: classes.buttonLabel,
              }}
              onClick={(ev) => {
                if (onUnstake) {
                  onUnstake();
                }
                closeModal();
              }}
            >
              Unstake
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default withRouter(withStyles(styles)(UnstakeModal));
